import Vue from 'vue'
import Vuex from 'vuex'
import VueCompositionApi from '@vue/composition-api'
import ContentSwitchWidget from './components/ContentSwitch.vue'
import store from './store/index'

Vue.config.productionTip = false

Vue.use(VueCompositionApi)
Vue.use(Vuex)

let widgets = document.querySelectorAll('widget-content-switch')
if (widgets.length) {
    widgets.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                let type = this.$el.attributes.getNamedItem('switch-type')
                let filters = this.$el.attributes.getNamedItem('impersonation-filters')
                let labels = this.$el.attributes.getNamedItem('labels')
                let language = this.$el.attributes.getNamedItem('language')
                let searchIndex = this.$el.attributes.getNamedItem('search-index')

                return h(ContentSwitchWidget, {
                    props: {
                        widgetType: type ? type.value : null,
                        configRaw: {
                            filters: filters ? JSON.parse(filters.value) : null,
                            labels: labels ? JSON.parse(labels.value) : null,
                            language: language ? language.value : null,
                            searchIndex: searchIndex ? searchIndex.value : null,
                        },
                    }
                })
            }
        })
    })
}
